"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"

import { Checkbox } from "@/components/ui/checkbox"
import BeaconsRowActions from "./BeaconsRowActions"
import { format } from "date-fns"


export type Beacons = {
    id: string,
    beacon_store_id: number,
    beacon_store_name: string,
    beacon_type_id: number,
    beacon_type_name: string,
    cid: string,
    tag_no: string,
    config_status: number,
    install_status: number,
    created_at: Date,
    updated_at: Date
}
interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    roles: string[]
    onViewAudits: (data: any) => void;
}
export const BeaconsColumns = ({ onEdit, onDelete, roles,onViewAudits }: rowActionProps): ColumnDef<Beacons>[] => {
    const columns: ColumnDef<Beacons>[] = [

        {
            accessorKey: "id",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        id
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
        },
        {
            accessorKey: "beacon_store_name",
            header: "Beacon Store ",
        },
        {
            accessorKey: "beacon_type_name",
            header: "beacon type",
        },
        {
            accessorKey: "cid",
            header: "Beacon Cid",
        },
        {
            accessorKey: "config_status",
            header: "Config Status",
            cell: ({ row }) => {
                const value: any = row.original
                const statusText = value.config_status === 1 ? "Configured" : "Not Configured";
                const bgColor = value.config_status === 1 ? "bg-green-500" : "bg-red-500";

                return (
                    <span className={`px-2  rounded-full ${bgColor} text-white`}>
                        {statusText}
                    </span>
                );
            },
        },
        {
            accessorKey: "install_status",
            header: "Install Status",
            cell: ({ row }) => {
                const value: any = row.original
                const statusText = value.install_status === 1 ? "Installed" : "Not Installed";
                const bgColor = value.install_status === 1 ? "bg-green-500" : "bg-red-500";

                return (
                    <span className={`px-2  rounded-full ${bgColor} text-white`}>
                        {statusText}
                    </span>
                );
            },
        },
        {
            accessorKey: "tag_no",
            header: "TagNo",
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },
    ]

    if (roles.includes('beacon-delete') || roles.includes('beacon-edit')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <BeaconsRowActions row={row} onEdit={onEdit} onDelete={onDelete} roles={roles} onViewAudits={onViewAudits}/>,
        })
    }

    return columns
}